import './index.css';

import React, { Component } from 'react';

export default class Card extends Component {
    className()
    {
        const defaultClasses = 'materialCard card ';
        let finalClasses = defaultClasses;

        if (this.props.className){
            finalClasses = finalClasses + ' ' + this.props.className;
        }

        return finalClasses;
    }

    render()
    {
        return(
            <div {...this.props} className={this.className()}>
                {this.props.children}
            </div>
        )
    }

}
